export const config = {
    url: ''
    // url: 'https://stage.iranhotelonline.com/'
    // url: 'https://www.iranhotelonline.com/'
    // AngularMVC/FAQ
}